import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LayersClearIcon(props: IconProps) {
    return <Icon {...props} iconKey={"layers_clear"}/>
}
